import { useQueryClient } from '@tanstack/react-query';
import type { Note as TNote } from '@restworld/utility-types';
import { SkeletonEmployerCardLoading } from '@restworld/ui-components';

import { useNoteQueryKey } from '.';
import { CandidateNoteItem } from './candidate-note-item';
import { cn } from '@restworld/utils-common';

export const CandidateNotesList = () => {
  const queryClient = useQueryClient();
  const notesQueryKey = useNoteQueryKey();
  const notesList = queryClient.getQueryData<TNote[]>(notesQueryKey);
  const isPending = queryClient.getQueryState(notesQueryKey)?.status === 'pending';

  return (
    <Wrapper>
      {isPending ? (
        <SkeletonEmployerCardLoading />
      ) : (
        notesList?.map((note) => <CandidateNoteItem key={note.id} {...note} />)
      )}
    </Wrapper>
  );
};
const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      'pb-5 min-h-[calc(100vh_-_21.5rem)] md:h-[calc(100vh_-_21.5rem)] md:pb-0 md:overflow-auto relative',
      className
    )}
    {...props}
  />
);
